import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Welcome from './screens/Welcome';
import { Route, Routes } from "react-router-dom";
import AppContext from './contexts/AppContext';
import { useTheme } from './services/themeService';

function App() {

    useTheme();

    return (
        <AppContext>
            <Routes>
                <Route path="/" element={<Welcome />} />
            </Routes>
        </AppContext>
    );
}

export default App;